<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'usuario-gerenciar') {
            next({ name: 'usuario-gerenciar-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'usuario-gerenciar') {
            this.$router.push({ name: 'usuario-gerenciar-list' });
        }
    },
};
</script>
